import React from 'react';
import { motion } from 'framer-motion';
import './LoadingSpinner.css';

const LoadingSpinner = ({
  size = 'md',
  color = 'primary',
  fullScreen = false,
  inline = false,
  message = null
}) => {
  const sizeClasses = {
    sm: 'spinner-sm',
    md: 'spinner-md',
    lg: 'spinner-lg',
  };

  const colorClasses = {
    primary: 'spinner-primary',
    secondary: 'spinner-secondary',
    white: 'spinner-white',
  };

  // `inline` strips the wrapper's padding + column-flex so the spinner can sit
  // next to text inside a button without inflating its height or pushing the
  // label off-center. Used by buttons like "Creating…" / "Saving…".
  const spinner = (
    <div className={`loading-spinner ${fullScreen ? 'loading-spinner-fullscreen' : ''} ${inline ? 'loading-spinner-inline' : ''}`}>
      <motion.div
        className={`spinner ${sizeClasses[size]} ${colorClasses[color]}`}
        animate={{ rotate: 360 }}
        transition={{
          duration: 1,
          repeat: Infinity,
          ease: "linear"
        }}
      />
      {message && (
        <motion.p
          className="loading-message"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          {message}
        </motion.p>
      )}
    </div>
  );

  return spinner;
};

export default LoadingSpinner;

